<template>
  <v-dialog
    v-model="isShow"
    max-width="1000"
    persistent
  >
    <template v-slot:activator="{ on }">
      <v-tooltip
        top
        color="black"
        :activator="$refs.btn"
        :value="tooltip"
      >
        <span>{{ $t('TaskList.Transfer.SystemMessage') }}</span>
      </v-tooltip>

      <v-btn
        ref="btn"
        icon
        color="light-blue"
        :class="cssClass"
        :disabled="disabled"
        v-on="on"
        @mouseover="tooltip = true"
        @mouseleave="tooltip = false"
        @click="prepareFileList()"
      >
        <v-icon>
          {{ mdiRedo }}
        </v-icon>
        <!-- 轉交 -->
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline px-4">
        {{ $t('TaskList.TransferToOthers') }}
      </v-card-title>

      <v-form
        ref="transferForm"
      >
        <v-card-text>
          <div>
            <v-checkbox
              v-if="prefillInfo && (prefillInfo.prefilledInstruction || prefillInfo.preFilledReceiverTOList.length)"
              v-model="isAgreeInstruction"
              :label="$t('eDocSuggest.agreeInstruction')"
              @click="clickAgreeInstructionHandler"
            />
          </div>
          <div
            v-if="prefillInfo"
            class="mb-1"
          >
            <s-attachment-list
              :process-id="edoc.dfProcessId"
              :file-list="prefillInfo.fileList"
              :pass-file-list.sync="forwardedOrDeletedFiles"
            />
          </div>
          <div
            v-if="!openerList || openerList.length === 0"
            class="mb-2"
          >
            <s-file-uploader-box-style
              ref="attachUploader"
              multiple
              :post-url="uploadFileUrl"
              extensions=""
              accept=""
              :maximum="10"
              use-attachment-icon
              :response.sync="attachDocResponse"
              :label="$t('eDocInternal.additionalFile')"
              @uploadError="onUploadError"
            />
          </div>
          <div class="grey lighten-3 pa-4 mx-n4 mb-4">
            <div class="text-body-2 mb-4">
              <span class="green--text">#</span>
              {{ $t('eDocSuggest.hint.messageIsPrefilled') }}
            </div>
            <v-btn
              v-for="(cannedMsg, index) in DOC_FLOW_CANNED_MSG_I18NS"
              :key="index"
              depressed
              rounded
              class="mb-2 mr-2"
              style="border: 2px solid #fff"
              @click="appendMsgToPreFilledInstruction($t(cannedMsg))"
            >
              {{ $t(cannedMsg) }}
            </v-btn>
            <v-textarea
              v-model="prefilledInstruction"
              :label="$t('eDocSuggest.prefilledInstruction')"
              rows="1"
              auto-grow
              filled
              background-color="white"
              hide-details
              class="mb-4"
            />

            <s-search-staff-muti
              v-model="preFilledReceiverEuid"
              show-group
              :label="$t('eDocInternal.recommandReceiver')"
              filled
              background-color="white"
              hide-details
              @dataChange="preFilledReceiverObject = $event"
            />
          </div>
          <v-textarea
            v-if="isShowSenderNote"
            v-model="senderNote"
            rows="1"
            auto-grow
            :label="$t('TaskList.MsgToNext')"
          />

          <s-add-encrypt-staff
            v-if="openerList && openerList.length && isMeOpener"
            :opener-list="openerList"
            :new-openers-euid.sync="newOpenersEuid"
            :new-openers-obj.sync="newOpenersObj"
          />

          <!-- 轉交專用 -->
          <s-search-staff-muti
            v-model="reassignedToEuid"
            show-group
            :label="$t('eDocSuggest.history.receiver')"
            @dataChange="reassignedToStaffObj = $event"
          />
        </v-card-text>
        <v-card-actions>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>
                  {{ mdiDotsHorizontal }}
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="isShowSenderNote = !isShowSenderNote">
                <v-list-item-title>
                  <template v-if="isShowSenderNote">
                    {{ $t('eDocSuggest.cancelPrivateMsg') }}
                  </template>
                  <template v-else>
                    {{ $t('eDocSuggest.addPrivateMsg') }}
                  </template>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="isShow = false"
          >
            {{ $t('PublicServant.Action.Close') }}
          </v-btn>
          <v-btn
            :loading="transferLoading"
            color="primary"
            @click="confirm"
          >
            {{ $t('ConfirmModal.OK') }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
  <!-- </div> -->
</template>

<script>
import { mdiRedo, mdiMessageText, mdiDotsHorizontal } from '@mdi/js'
// import { mapState } from 'vuex'
import VuetifyJetValidator from 'vuetify-jet-validator'

// import SSearchStaff from '@/components/SSearchStaff'
import SSearchStaffMuti from '@/components/SSearchStaffMuti'
import { globalModule } from '@/store/moduleName'
// import { taskMethod } from '@/mixins/taskMethod'
// import { SEARCH_STAFF_RECORD_TYPE } from '@/constant/constant'
import _ from 'lodash'
import { docFlowMethod } from '@/mixins/docFlowMethod'
// import { docFlowModule } from '@/store/moduleName'
import SFileUploaderBoxStyle from '@/components/SFileUploaderBoxStyle'
import SAttachmentList from './SAttachmentList'
import docFlowApi from '@/api/eDocInternal/docFlow'
import SAddEncryptStaff from './SAddEncryptedStaff.vue'
import { uploadMethod } from '@/mixins/uploadMethod'
import { DOC_FLOW_ACTION_TYPE, DOC_FLOW_CANNED_MSG_I18NS } from '@/constant/constant'
import messageUtil from '@/utils/messageUtil'
// import { DOC_FLOW_TYPE } from '@/constant/constant'
import { encryptMethod } from '@/mixins/encryptMethod'

const validator = new VuetifyJetValidator()

export default {
  components: {
    // SSearchStaff,
    SSearchStaffMuti,
    SFileUploaderBoxStyle,
    SAttachmentList,
    SAddEncryptStaff
  },
  mixins: [docFlowMethod, uploadMethod, encryptMethod],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    cssClass: {
      type: String,
      default: null
    },
    currGroupId: {
      type: Number,
      default: null
    },
    docFlowStatus: {
      type: Array,
      default: function () {
        return []
      }
    },
    edoc: {
      type: Object,
      default: null
    },
    // processId: {
    //   type: Number,
    //   default: null
    // },
    uploadFileUrl: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      mdiRedo: mdiRedo,
      mdiMessageText: mdiMessageText,
      mdiDotsHorizontal,
      reassignedToEuid: [],
      reassignedToStaffObj: [],
      reassignedToHistoryItem: null,
      isShow: false,
      tooltip: false,
      transferLoading: false,
      isShowSenderNote: false,
      senderNote: '',
      preFilledReceiverEuid: [],
      preFilledReceiverObject: [],
      prefilledInstruction: null,
      prefillInfo: null,
      attachDocResponse: [],
      processAttachmentList: [],
      forwardedOrDeletedFiles: [], // Forwarded or deleted file info that will pass to next staff
      rules: {
        requiredField: [
          validator.rules.required(this.$t('TrainingClient.RequiredField'))
        ]
      },
      DOC_FLOW_CANNED_MSG_I18NS,
      isAgreeInstruction: false
      // openerList: [],
      // newOpenersEuid: [],
      // newOpenersObj: [] // for checking opener's public key is generated or not
    }
  },
  computed: {
    /* ...mapState(staffModule, {
      // staffPhoto: state => state.photoInBase64,
      staff: state => state.info
    }) */
  },
  // watch: {
  //   newOpenersObj: {
  //     handler: async function (val) {
  //       this.transferLoading = true
  //       await this.checkAndShowNoKeyPairUser(val)
  //       this.transferLoading = false
  //     }
  //   },
  //   deep: true
  // },
  async created () {
    this.confirm = _.debounce(this.debounceConfirm, 1000, { leading: true, trailing: false })
    docFlowApi.getProcessPrefillInfo(this.edoc.dfProcessId, resp => {
      this.prefillInfo = resp.data
    })
  },
  methods: {
    staffOrGroupName (item) {
      if (this.$chPtObjData('messageFromGroupChinName', item)) {
        return this.$chPtObjData('messageFromGroupChinName', item)
      } else {
        return this.$chPtObjData('chinStaffName', item)
      }
    },
    async debounceConfirm () {
      this.transferLoading = true
      if (!this.$refs.transferForm.validate()) {
        this.transferLoading = false
        return false
      }

      if (!this.reassignedToEuid || !this.reassignedToEuid.length) {
        this.transferLoading = false
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('eDocSuggest.history.receiver')]))
        return false
      }

      if (await this.checkAndShowNoKeyPairUser(this.newOpenersObj)) {
        this.transferLoading = false
        return false
      }

      this.attachDocResponse.forEach(attach => {
        this.processAttachmentList.push({
          docCode: attach.response,
          docName: attach.name,
          actionType: DOC_FLOW_ACTION_TYPE.ADD,
          id: null
        })
      })
      this.forwardedOrDeletedFiles.forEach(file => {
        this.processAttachmentList.push(file)
      })

      let data = {
        'nextStaffObj': this.reassignedToStaffObj,
        'senderNote': this.senderNote,
        'preFilledReceiver': this.preFilledReceiverObject,
        'prefilledInstruction': this.prefilledInstruction,
        'processAttachmentList': this.processAttachmentList,
        'oriStatusCode': this.edoc.statusCode
      }

      if (this.openerList && this.openerList.length && this.newOpenersEuid && this.newOpenersEuid.length) {
        await docFlowApi.addDocumentOpener(this.edoc.dfProcessId, await this.buildEncryptedOpenerData(this.newOpenersEuid), resp => {
          if (resp.status === 201 || resp.status === 200) {
            console.log('add openers successfully')
          } else {
            messageUtil.httpStatusHandler(resp, this)
            this.transferLoading = false
            return false
          }
        })
      }

      if (this.openerList && this.openerList.length && this.newOpenersEuid && this.newOpenersEuid.length) {
        await docFlowApi.addDocumentOpener(this.edoc.dfProcessId, await this.buildEncryptedOpenerData(this.newOpenersEuid), resp => {
          if (resp.status === 201 || resp.status === 200) {
            console.log('add openers successfully')
          } else {
            messageUtil.httpStatusHandler(resp, this)
            this.transferLoading = false
            return false
          }
        })
      }

      await this.transferProcessToStaff(this.edoc.dfProcessId, data)
      // await this.$store.dispatch(docFlowModule + '/getProcessList', { 'pageNum': this.pageNum, 'status': this.docFlowStatus })
      // await this.$store.dispatch(docFlowModule + '/getProcessList', { 'pageNum': this.pageNum, 'status': this.docFlowStatus, 'orderByKey': this.orderingProp, 'isContainPrefilledReceiverOnly': this.onlyShowSuggestAndReceiver, 'pageSize': this.pageSize, 'isContainPrefilledInsOnly': this.onlyShowSuggestAndReceiver })
      this.getProcessList(this.onlyShowPrefilled, this.filterText, this.docFlowStatus)
      this.clearObjects()
      this.$emit('back')
      this.isShow = false
    },

    clearObjects () {
      if (this.$refs.attachUploader) {
        this.$refs.attachUploader.clearFile()
      }
      this.$refs.transferForm.reset() // reset all input and validation
    },

    appendMsgToPreFilledInstruction: function (msg) {
      if (this.prefilledInstruction) {
        this.prefilledInstruction += msg
      } else {
        this.prefilledInstruction = msg
      }
    },

    clickAgreeInstructionHandler: function () {
      if (this.isAgreeInstruction === true) {
        this.preFilledReceiverEuid = []
        this.prefilledInstruction = null
        if (this.prefillInfo) {
          this.prefillInfo.preFilledReceiverTOList.forEach(obj => {
            if (obj.euid) {
              this.preFilledReceiverEuid.push(obj.euid)
            } else {
              this.preFilledReceiverEuid.push(obj.gid + '') // Integer causes some problems for SSearchStaffMuti
            }
          })
          this.prefilledInstruction = this.prefillInfo.prefilledInstruction
        }
      }
    },

    prepareFileList: function () {
      if (this.isMeOpener && !this.decryptedFileKey) {
        this.previewFileList(this.edoc.dfProcessId, false) // find the encrypted document and get the "encryptedFileKey". Then set the key into store 'commonComponent' for decrypting file.
      }
    }
  }
}
</script>
